import { ref } from 'vue'
import type { Stage } from '@/types/adventurer'
import type { StageChanges } from './useStageManagement'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

interface ProgressStatusUpdateResponse {
  success: boolean
  message: string
}

export function useProgressStatusUpdate() {
  const isUpdating = ref(false)

  const updateProgressStatus = async (
    username: string,
    stage: Stage,
    changes: string | StageChanges
  ): Promise<ProgressStatusUpdateResponse> => {
    isUpdating.value = true

    try {
      const data: Record<string, string | number> = {}
      
      if (typeof changes === 'object') {
        if (changes.status) data[`${stage}_status`] = changes.status
        if (changes.attempts) data[`${stage}_status_attempts`] = changes.attempts
        if (changes.notes) data[`${stage}_status_notes`] = changes.notes
      } else {
        data[stage] = changes
      }

      await api.patch(API_ROUTES.EDIT_FELLOW_DATA(username), data)

      return {
        success: true,
        message: `Successfully updated ${stage} status`
      }
    } catch (error) {
      console.error('Error updating progress status:', error)
      throw error
    } finally {
      isUpdating.value = false
    }
  }

  return {
    isUpdating,
    updateProgressStatus
  }
}